import { BAD_REQUEST_CODE, CONFLICT_CODE } from '~/src/models/constants/status-codes';
import { LEAD_ALL_REFERRAL_POPUP_DATA, PAGE_CONTEXT, TYPE_ERROR_ACTION } from '~/src/repositories/lead/constants';
import { badRequestHandler } from '../../helper/bad-request-handler.helper';
import { generatePopupId } from '../../helper/generate-popup-id';
import { onSendErrorRequestEventAnalytics } from '../../analytics/create-lead-all-referral.analytics';
import type { ExtendedAxiosResponse, InternalDataFieldInterface } from '~/src/models/types/axios-response.types';
import type { ErrorMapping } from '../../types/error-handlers.types';

export const getAllReferralErrorMapping = (onSuccess: () => void): ErrorMapping => ({
    [BAD_REQUEST_CODE]: (error: ExtendedAxiosResponse<InternalDataFieldInterface>) =>
        badRequestHandler(error, PAGE_CONTEXT.LEAD_ALL_REFERRAL, onSendErrorRequestEventAnalytics),

    [CONFLICT_CODE]: () => ({
        action: {
            type: TYPE_ERROR_ACTION.popup,
            config: LEAD_ALL_REFERRAL_POPUP_DATA,
            popupId: generatePopupId(PAGE_CONTEXT.LEAD_ALL_REFERRAL, CONFLICT_CODE),
        },
        effects: {
            afterAction: onSuccess,
        },
    }),
});